"use client";
import dynamic from "next/dynamic";
import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";

import SwiperSlider from "../app/components/SwiperSlider";

import "bootstrap-icons/font/bootstrap-icons.css";
import { useDispatch, useSelector } from "react-redux";
import { getTotalVendorCountThunk } from "./features/thunks/vendorThunk";
import SlotCounter from "react-slot-counter";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import Loader from "@/components/Loader";
import { Modal } from "react-bootstrap";

// Load Header client-side only
const Header = dynamic(() => import("../app/components/Header/page.js"), {
  ssr: false,
});

function Page() {
  const dispatch = useDispatch();
  const router = useRouter();
  const searchParams = useSearchParams();
  const refCode = searchParams.get("ref");
  const pathname = usePathname();

  const [loading, setLoading] = useState(true);
  const [totalDownloads, setTotalDownloads] = useState(0);
  const [totalVendors, setTotalVendors] = useState(0);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const token = useSelector((store) => store?.auth?.user?.accessToken);
  const totatVendorsCount = useSelector(
    (store) => store.vendor.totatVendorsCount
  );

  useEffect(() => {
    // Example: /my-page?name=John
    if (refCode) {
      const triggerBtn = document.querySelector('[data-bs-target="#signUp"]');
      triggerBtn?.click();
    }
  }, [refCode]);

  useEffect(() => {
    const initPage = async () => {
      setLoading(true);
      await dispatch(getTotalVendorCountThunk());
      if (token) {
        router.push("/home");
      } else {
        setLoading(false);
        setIsAuthorized(false);
      }
    };

    initPage();
  }, []);

  useEffect(() => {
    if (totatVendorsCount) {
      setTotalDownloads(
        parseInt(totatVendorsCount?.download_user_count, 10) || 0
      );
      setTotalVendors(parseInt(totatVendorsCount?.vendor_count, 10) || 0);
    }
  }, [totatVendorsCount]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {/* Navbar section  */}
      <Header />

      {/* Banner section  */}

      <section className="section-spacing">
        <div className="container">
          <div className="row align-items-center position-relative banner-main">
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="banner-content banner-info1">
                <p className="banner-subhead">Plan Less, Experience More</p>
                <h2 className="banner-head">
                  Discover Local Bartenders, Bakeries, Private Chefs, Catering
                  to the Florist
                </h2>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 px-0 mb-3 mb-md-0">
              <div className="banner-content banner-image">
                <img
                  src="/images/banner-img.png"
                  alt="banner"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-12 col-lg-4 mb-3 banner-section-spacing-onmobile">
              <div className="banner-content">
                <div className="d-flex hero-app-btn">
                  <div className="banner-app">
                    <p className="banner-active-text">Downloads</p>
                    <h4 className="banner-active-num">
                      <SlotCounter value={totalDownloads} />+
                    </h4>
                  </div>
                  <div className="banner-app">
                    <p className="banner-active-text">Active Vendor</p>
                    <h4 className="banner-active-num">
                      <SlotCounter value={totalVendors} />+
                    </h4>
                  </div>
                </div>
                <p className="banner-des">
                  Discover top-rated local vendors for any occasion. Whether
                  you're planning a party, a wedding, or a cozy dinner, our app
                  connects you with the best.
                </p>
                <div className="header-btn-app-main">
                  <p className="download-now-text">Download now on:</p>
                  <div className="d-flex header-btn-app">
                    {/* <button
                      className="btn google-play-btn d-flex text-start align-items-center"
                      type="button"
                    > */}
                    <a
                      target="_blank"
                      href={process.env.NEXT_PUBLIC_PLAYSTORE}
                      type="button"
                      className="btn google-play-btn d-flex text-start align-items-center"
                    >
                      <Image
                        src="/images/google-play-logo.svg"
                        alt="Google play"
                        width={21}
                        height={23}
                      />
                      <div className="app-btn-spacing">
                        <span className="text-transform-uppercase">
                          GET IT ON
                        </span>
                        <h5>Google Play</h5>
                      </div>
                    </a>
                    {/* </button> */}
                    <a
                      target="_blank"
                      href={process.env.NEXT_PUBLIC_APPSTORE}
                      className="btn google-play-btn d-flex text-start align-items-center"
                      type="button"
                    >
                      <Image
                        src="/images/apple-logo.svg"
                        alt="apple logo"
                        width={18}
                        height={21}
                      />
                      <div className="app-btn-spacing">
                        <span>Download on the</span>
                        <h5>App Store</h5>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial section  */}
      <SwiperSlider />

      {/* Become a Customer section  */}

      <section className="mb-2 mb-md-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6">
              <div className="customer-info">
                <h2 className="customer-head"> Become a Customer</h2>
                <p className="customer-des">
                  Whether you're planning a celebration or just need everyday
                  services, our app puts the best local talent right at your
                  fingertips.
                </p>
                <div>
                  <strong className="fst-italic">Why Join?</strong>
                  <div className="d-flex mt-3">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      One app, all your needs – from food to flowers
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Safe, reliable, and reviewed vendors
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Fast, direct access — no middleman
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Simple, smooth browsing experience
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="customer-banner">
                <img
                  src="/images/customer-banner.png"
                  alt="check"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Become a Vendor section  */}

      <section className="mb-3 mb-md-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6">
              <div className="customer-banner">
                <img
                  src="/images/vendor.png"
                  alt="check"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="customer-info">
                <h2 className="customer-head">Become a Vendor</h2>
                <p className="customer-des">
                  Showcase your skills, connect with more clients, and grow your
                  business — all through our app.
                </p>
                <div>
                  <strong className="fst-italic">What You’ll Get:</strong>
                  <div className="d-flex mt-3">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Exposure to a large local audience
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      A beautiful vendor profile to highlight your work
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Bookings directly from interested users
                    </p>
                  </div>
                  <div className="d-flex">
                    <Image
                      src="/images/check.svg"
                      alt="check"
                      width={23}
                      height={23}
                    />
                    <p className="ms-3 customer-text">
                      Tools to manage your availability and services
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it works section  */}

      <section className="mb-3 mb-md-5">
        <div className="container">
          <div className="row align-items-center px-3">
            <div className="mb-4">
              <h2 className="customer-head text-center">How it works</h2>
              <p className="customer-des text-center">
                A seamless experience, from first tap to final toast.
              </p>
            </div>
            <div className="col-12 d-flex align-items-center work-content-bx">
              <div className="how-it-work-icon">
                <a href="#" className="work-icons">
                  <Image
                    src="/images/work-icon1.svg"
                    alt="Download the App"
                    width={30}
                    height={30}
                  />
                </a>
              </div>
              <div className="how-it-content">
                <h4 className="work-head">Download the App</h4>
                <p className="work-para mb-0">
                  Get OneStop from the App Store or Google Play. Setup takes
                  less than a minute.
                </p>
              </div>
            </div>

            <div className="col-12 d-flex align-items-center work-content-bx">
              <div className="how-it-work-icon">
                <a href="#" className="work-icons">
                  <Image
                    src="/images/work-icon2.svg"
                    alt="Create Your Profile"
                    width={30}
                    height={30}
                  />
                </a>
              </div>
              <div className="how-it-content">
                <h4 className="work-head">Create Your Profile</h4>
                <p className="work-para mb-0">
                  Tell us what you’re looking for—or what you offer. Whether
                  you’re planning a night in or a night to remember, we’ll
                  tailor the experience to you.
                </p>
              </div>
            </div>

            <div className="col-12 d-flex align-items-center work-content-bx">
              <div className="how-it-work-icon">
                <a href="#" className="work-icons">
                  <Image
                    src="/images/work-icon3.svg"
                    alt="Book or List Services"
                    width={30}
                    height={30}
                  />
                </a>
              </div>
              <div className="how-it-content">
                <h4 className="work-head">Book or List Services</h4>
                <p className="work-para mb-0">
                  Browse verified local vendors—from chefs to florists—and book
                  instantly. Or, as a vendor, list your services and start
                  receiving bookings from high-intent customers
                </p>
              </div>
            </div>

            <div className="col-12 d-flex align-items-center work-content-bx">
              <div className="how-it-work-icon">
                <a href="#" className="work-icons">
                  <Image
                    src="/images/work-icon4.svg"
                    alt="Chat, Confirm, and Enjoy"
                    width={30}
                    height={30}
                  />
                </a>
              </div>
              <div className="how-it-content">
                <h4 className="work-head">Chat, Confirm, and Enjoy</h4>
                <p className="work-para mb-0">
                  Message directly within the app, confirm details, and relax.
                  Your event is in good hands—from first impression to final
                  bite.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience section  */}

      <section className="mb-5 experince-section">
        <div className="container">
          <div className="mb-4">
            <h2 className="customer-head text-center">
              What’s waiting for you on OneStop, a world <br /> of top curated
              experiences
            </h2>
            <p className="customer-des text-center">
              All in one place. Whether you're planning an intimate dinner, a
              company lunch, or a backyard <br /> celebration, OneStop gives you
              direct access to the best your city has to offer—personalized,
              verified, <br />
              and ready when you are. Here’s what you’ll unlock
            </p>
          </div>
          <div className="row align-items-center mt-5">
            <div className="col-md-12 col-lg-5">
              <div className="expe-img">
                <img
                  src="/images/exp-img.png"
                  alt="Download the App"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-12 col-lg-7">
              <div className="d-flex align-items-center work-content-bx border-0 p-2">
                <div className="how-it-work-icon">
                  <a href="#" className="work-icons">
                    <Image
                      src="/images/exp-icon1.svg"
                      alt="Top-Rated Local Talent"
                      width={30}
                      height={30}
                    />
                  </a>
                </div>
                <div className="how-it-content">
                  <h4 className="work-head">Top-Rated Local Talent</h4>
                  <p className="work-para mb-0">
                    Discover vetted chefs, bakers, bartenders, florists, DJs,
                    and more—all in your neighborhood.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center work-content-bx border-0 p-2">
                <div className="how-it-work-icon">
                  <a href="#" className="work-icons">
                    <Image
                      src="/images/exp-icon2.svg"
                      alt="One Tap, Endless Options"
                      width={30}
                      height={30}
                    />
                  </a>
                </div>
                <div className="how-it-content">
                  <h4 className="work-head">One Tap, Endless Options</h4>
                  <p className="work-para mb-0">
                    From private dinners to meal prep, cooking classes to
                    catering—browse, book, and manage everything in one place.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center work-content-bx border-0 p-2">
                <div className="how-it-work-icon">
                  <a href="#" className="work-icons">
                    <Image
                      src="/images/exp-icon3.svg"
                      alt="Tailored to You"
                      width={30}
                      height={30}
                    />
                  </a>
                </div>
                <div className="how-it-content">
                  <h4 className="work-head">Tailored to You</h4>
                  <p className="work-para mb-0">
                    Smart recommendations match you with vendors based on your
                    tastes, needs, and event style.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center work-content-bx border-0 p-2">
                <div className="how-it-work-icon">
                  <a href="#" className="work-icons">
                    <Image
                      src="/images/exp-icon4.svg"
                      alt="Trust Built In"
                      width={30}
                      height={30}
                    />
                  </a>
                </div>
                <div className="how-it-content">
                  <h4 className="work-head">Trust Built In</h4>
                  <p className="work-para mb-0">
                    Transparent pricing, verified reviews, and direct messaging
                    ensure you’re always in control.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center work-content-bx border-0 p-2">
                <div className="how-it-work-icon">
                  <a href="#" className="work-icons">
                    <Image
                      src="/images/exp-icon5.svg"
                      alt="No Guesswork"
                      width={30}
                      height={30}
                    />
                  </a>
                </div>
                <div className="how-it-content">
                  <h4 className="work-head">
                    No Guesswork. No Middlemen. Just Magic.
                  </h4>
                  <p className="work-para mb-0">
                    One app. Infinite experiences. Welcome to your new way to
                    plan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="my-5">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <a href="/images/case_study_03.png" target="_blank">
                <img
                  src="/images/case_study_03.png"
                  alt="Green Minimalist Company"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="col-md-4">
              <a href="/images/case_study_01.png" target="_blank">
                <img
                  src="/images/case_study_01.png"
                  alt="Green Minimalist Company"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="col-md-4">
              <a href="/images/case_study_02.png" target="_blank">
                <img
                  src="/images/case_study_02.png"
                  alt="Green Minimalist Company"
                  className="img-fluid"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Experience section  */}

      <section>
        <div className="container">
          <div className="mb-4">
            <h2 className="customer-head text-center">Download the App</h2>
            <p className="customer-des text-center">
              Discover chefs, decorators, photographers, bartenders, and more —
              all in one easy-to-use app. Whether <br /> you're planning an
              event or just looking for everyday services, we’ve got the right
              vendor for you.
            </p>
          </div>
          <div className="download-image d-flex justify-content-center">
            <img
              src="/images/download-ss.png"
              alt="download image"
              className="img-fluid"
            />
          </div>
        </div>
      </section>

      {/* footer section  */}
    </>
  );
}

export default Page;
